//@flow

// Vendors
import React from 'react';
import { useDispatch } from 'react-redux';

// Components
import { Modal } from '../../../../modals';
import Trans from '../../../../Trans/Trans';
import { ButtonPrimary } from 'texkit/dist/components/Buttons';

// Actions
import { closeModal } from '../../../../../../reducers/modal/modalActions';

// Styles
import '../dps-FAQ-modal.scss';

const DPS_Order_In_Process_Modal = () => {
  const dispatch = useDispatch();
  return (
    <Modal name="DPS_Order_In_Process_Modal" className="faq-modal">
      <h2 className="h1 modal-title-general">
        <Trans file="dps" id="dps_Order_In_Process" />
      </h2>
      <p className="modal-description-general">
        <Trans file="dps" id="dps_Order_In_Process_Desc" />
      </p>

      <ButtonPrimary
        className="modal-close-button-general"
        onClick={() => dispatch(closeModal('DPS_Order_In_Process_Modal'))}
      >
        <Trans file="Labels" id="okGotIt" />
      </ButtonPrimary>
    </Modal>
  );
};

export default DPS_Order_In_Process_Modal;
